import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import IncomeStatementWidget from "../../../finance/widgets/income-statement";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import AbbreviatedMillionNumberFormat from "../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class TeamReportsSection4Step3 extends PureComponent {
  get left_content() {
    const { netRevenues, costOfSales } = this.props;

    return (
      <span>
        <u>Financial Impact of Your Decisions</u>
        <br />
        <br />
        Both Product Management and Marketing decisions impact the following
        line items:
        <br />
        <br />- <b>Net Revenues:</b> Your Net revenues of{" "}
        <AbbreviatedMillionNumberFormat
          value={netRevenues}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        was driven by the attractiveness of your Marketing Mix in relation to
        your competitors.
        <br />
        <br />- <b>Cost of Sales:</b> Your Cost of Sales of{" "}
        <AbbreviatedMillionNumberFormat
          value={costOfSales}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        was partly driven by the product feature quality. The higher the
        quality, the more expensive the materials that is needed to produce the
        product.
        <br />
        <br />
        To learn more about what impacts your Gross Profits, please review the
        following content:
        <br />
        <TypeformLink title="STP" url={TypeformUrls.STP} />
        <TypeformLink
          title="Marketing Mix"
          url={TypeformUrls.MARKETING_MIX}
          className="link-with-margin"
        />
        <TypeformLink
          title="Product Market Fit"
          url={TypeformUrls.PRODUCT_MARKET_FIT}
          className="link-with-margin"
        />
        <TypeformLink
          title="Product Costs"
          url={TypeformUrls.PRODUCT_COSTS}
          className="link-with-margin"
        />
      </span>
    );
  }

  get right_content() {
    const { incomeStatement, current_year } = this.props;

    return (
      <IncomeStatementWidget
        incomeStatement={incomeStatement}
        current_year={current_year}
      />
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Market Analysis"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection4Step3;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-4/step-3.js